import { Image } from 'antd'
import React, { useEffect, useState } from 'react'
import entete from "../../../assets/img/entete_pool.png"
import PropTypes from 'prop-types';
import BarreTop from '../../../components/docs/BarreTop';
import { frenchDate } from '../../../variables/functions';
import { DocumentFooter } from '../../../components/docs/DocumentFooter';
import { getCompagnieLogo } from '../../../hooks/useFilesHooks';

const NoteExpert = React.forwardRef((props, ref) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);

    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {
                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, []);

    const today = new Date().toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    });

    // En-tête + pied de page OPTIONNELS : désactivés → impression « nue » sur papier à en-tête,
    // avec corps CENTRÉ verticalement. Par défaut : affichés.
    const afficherEnteteEtPied = props?.afficherEnteteEtPied !== false;

    return (
        <div ref={ref} style={{
            fontFamily: "Calibri, 'Calibri Light', sans-serif",
            maxWidth: "800px",
            margin: "0 auto",
            padding: "20px 30px",
            lineHeight: 1.5,
            fontSize: "12pt",
            color: "#000000",
            display: "flex",
            flexDirection: "column",
            minHeight: "250mm",
            boxSizing: "border-box"
        }}>

            {/* En-tête avec logos — masquable pour impression sur papier à en-tête. */}
            {afficherEnteteEtPied && (
            <div style={{ marginBottom: "20px" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && logoPreviewUrl && (
                        <img
                            src={logoPreviewUrl}
                            style={{
                                width: "auto",
                                height: "60px",
                                objectFit: "contain"
                            }}
                            alt="Logo compagnie"
                        />
                    )}
                    <img
                        src={entete}
                        style={{
                            width: "auto",
                            height: "60px",
                            objectFit: "contain"
                        }}
                        alt="En-tête"
                    />
                </div>
                <div style={{ height: "2px", background: "linear-gradient(to right, #2563eb, #3b82f6)", marginTop: "8px" }} />
            </div>
            )}

            {/* Papier à en-tête : espace flexible en haut → centre le corps verticalement. */}
            {!afficherEnteteEtPied && <div style={{ flex: 1 }} />}

            {/* Référence en haut à gauche */}
            <div style={{ marginBottom: "40px" }}>
                <p style={{ margin: 0, fontSize: "11pt", color: "#000000" }}>
                    <strong>Réf:</strong> {props?.sinistre?.numSinistre || '......'}/KGW/......./......./Pool TPVM-VT GIE
                </p>
            </div>

            {/* Informations de l'expert à droite */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "40px" }}>
                <div style={{ textAlign: "left" }}>
                    <p style={{ margin: "0 0 3px 0", fontSize: "12pt", fontWeight: "bold" }}>
                        {props?.expertise?.expert?.civilite || 'Docteur'} {props?.expertise?.expert?.nom || 'Expert'}
                    </p>
                    <p style={{ margin: "0 0 3px 0", fontSize: "12pt" }}>
                        {props?.expertise?.expert?.adresse || 'CLINIQUE'}
                    </p>
                    <p style={{ margin: "0 0 3px 0", fontSize: "12pt" }}>
                        <strong>Tél :</strong> {props?.expertise?.expert?.contact?.[0] || ''}
                    </p>
                    <p style={{ margin: "0 0 3px 0", fontSize: "12pt" }}>
                        Lomé -Togo
                    </p>
                    <div style={{
                        borderBottom: "1px solid #000000",
                        margin: "8px 0",
                        width: "100%"
                    }} />
                    <p style={{ margin: "8px 0 0 0", fontSize: "12pt" }}>
                        Lomé, le {today}
                    </p>
                </div>
            </div>

            {/* Objet */}
            <div style={{ marginBottom: "30px", marginTop: "30px" }}>
                <p style={{ margin: 0, fontSize: "12pt", fontWeight: "bold" }}>
                    <b style={{ fontSize: "11pt", textDecoration: "underline", fontWeight: "bold" }}>Objet:</b>{' '}
                    <b style={{ fontSize: "11pt", fontWeight: "bold" }}>
                        SIN N° {props?.sinistre?.numSinistre || props?.sinistre?.numeroSinistreM} {props?.sinistre?.contrat?.souscripteur?.nom || ''} C/ {props?.expertise?.beneficiaire?.personne?.nom || ''}
                    </b>
                </p>
                <p style={{ margin: "5px 0 0 60px", fontSize: "12pt" }}>
                    <strong style={{ fontSize: "11pt" }}>
                        Accident du {props?.sinistre?.dateDeclaration ? new Date(props.sinistre.dateDeclaration).toLocaleDateString('fr-FR') : ''}
                    </strong>
                </p>
            </div>

            {/* Corps du texte */}
            <div style={{ textAlign: "justify", fontSize: "12pt", lineHeight: 1.5 }}>
                <p style={{ marginBottom: "15px" }}>
                    {props?.expertise?.expert?.genre === "FEMININ" ? "Docteure" : "Docteur"},
                </p>

                <p style={{ marginBottom: "15px" }}>
                    Dans le cadre du règlement transactionnel de l'affaire citée en marge, nous vous adressons la présente correspondance pour vous prier de bien vouloir examiner le nommé <strong>{props?.expertise?.beneficiaire?.personne?.prenom || ''} {props?.expertise?.beneficiaire?.personne?.nom || ''}</strong> et nous adresser votre rapport.
                </p>

                <p style={{ marginBottom: "15px" }}>
                    Pour toutes fins utiles, vous trouverez ci-joint la lettre que nous avons adressée à la victime à cet effet.
                </p>

                <p style={{ marginBottom: "15px" }}>
                    Dans l'attente des conclusions de votre rapport d'expertise médicale, nous vous prions d'agréer <strong>{props?.expertise?.expert?.genre === "MASCULIN" ? "Docteur" : "Docteure"}</strong>, l'expression de nos sentiments distingués.
                </p>
            </div>

            {/* Signature */}
            <div style={{ marginTop: "60px", textAlign: "right", marginBottom: "180px" }}>
                <p style={{ margin: "0", fontSize: "11pt", fontWeight: "bold", textDecoration: "underline" }}>
                    {props?.sinistre?.contrat?.organisme?.responsable || 'Koffi G. WARBUTIN'}
                </p>
                <p style={{ margin: "3px 0 0 0", fontSize: "11pt" }}>
                    {props?.signataire?.fonction || 'Directeur'}
                </p>
            </div>

            {/* Pièces jointes */}
            <div style={{ marginTop: "10px" }}>
                <p style={{ margin: 0, fontSize: "11pt" }}>
                    <strong style={{ textDecoration: "underline" }}>P.j :</strong> Certificats médicaux
                </p>
            </div>

            {/* Espace flexible : pousse le pied de page en bas (et complète le centrage sur papier à en-tête). */}
            <div style={{ flex: 1 }} />

            {afficherEnteteEtPied && <DocumentFooter />}
        </div>
    )
})

NoteExpert.propTypes = {
    expertise: PropTypes.object,
    sinistre: PropTypes.object,
    expert: PropTypes.object,
    signataire: PropTypes.object,
    /** false → imprimé sans en-tête ni pied (papier à en-tête), corps centré. */
    afficherEnteteEtPied: PropTypes.bool
}

export default NoteExpert